up.compiler(
  '[data-load-async]',
  (_element: HTMLElement, { target, url }: { target: string; url: string }) => {
    up.render({ target, url, history: false, navigate: false })
  },
)
